(function () {
  window.RestaurantGrowth = window.RestaurantGrowth || {};

  function sendEvent(eventName, params) {
    params = params || {};

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      console.log('[RestaurantGrowth] Event sent:', eventName, params);
    } else {
      console.warn('[RestaurantGrowth] gtag not found:', eventName, params);
    }
  }

  window.RestaurantGrowth.trackBookingClick = function (element) {
    sendEvent('book_table_click', {
      event_category: 'reservation',
      event_label: 'Online Reservation Header',
      link_url: element.href,
      restaurant: 'MOMO Asian Kitchen Bar'
    });
  };

  document.addEventListener('click', function (event) {
    var bookingButton = event.target.closest(
      '#HeaderMenu-online-reservation, a[href*="momo-asian.resos.com/booking"]'
    );

    if (bookingButton) {
      window.RestaurantGrowth.trackBookingClick(bookingButton);
    }
  });
})();